import { render, staticRenderFns } from "./ServiceAreaTable.vue?vue&type=template&id=0044676a&scoped=true&"
import script from "./ServiceAreaTable.vue?vue&type=script&lang=js&"
export * from "./ServiceAreaTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreaTable.vue?vue&type=style&index=0&id=0044676a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044676a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
